import React from 'react'

function LawfirmProfileReview({values}) {
    const Row = ({ label, value }) => (
  <div className="flex justify-between gap-4 py-2">
    <span className="text-xs text-gray-500">{label}</span>
    <span className="max-w-[65%] text-right text-xs font-medium text-navy break-all">
      {value}
    </span>
  </div>
);
  return (
    <div>
        <div className="">

        <div className="border border-gray-200 rounded-lg bg-cream/50 p-3 divide-y divide-gray-200">
            <Row label="Law Firm Name" value={values.company} />
            <Row label="Website" value={values.lawFirmLink} />
            <Row label="Phone" value={values.phoneNumber} />
        </div>
       
    </div>
    </div>
  );
}

export default LawfirmProfileReview
